const isMobileLayout = require('../helpers/isMobileLayout.js');

/**
 * When an item is placed in the shopping cart
 * show the item in a modal and update the cart badge value
 * 
 * @returns { void }
 */
const shoppingCardModal = () => {
  const modal = document.querySelector('.js-modal-cart-preview');
  const form = document.querySelector('.js-modal-cart-form');
  const cartBadge = document.querySelector('.js-cart');

  if(!modal || !form || !cartBadge) { return }
  
  const { url, error, timeOut } = getConfigOptions(modal, form);

  setEventListeners(modal, timeOut);

  form.addEventListener('submit', e => {
    e.preventDefault();

    if (!e.target.checkValidity() || !$(form).valid()) {
      return;
    }

    window.POSTBARE(url, new FormData(form))
      .then(data => {
        try {
          const json = JSON.parse(data.response);

          if(json.Success){

            clearTimeouts();
            insertModalContent(modal, json);
            setAutomaticFadeOut(modal, timeOut);

            cartBadge.classList.add('badge');
            cartBadge.setAttribute('data-badge', json.CartAmount);
          } else {
            insertModalError(form, json.ErrorMessage);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e, error);
          insertModalError(form, error);
        }
      })
      .catch(response => {
        // eslint-disable-next-line no-console
        console.error(response);
        insertModalError(form, error);
      });
  })
};

/**
 * Get end points and other options from the HTML element
 * 
 * @param { HTML } modal - modal that contains product item
 * @param { HTML } form - form that posts product data
 * 
 * @returns { string } url - url to the endpoint
 * @returns { string } error - general error message when call fails
 * @returns { integer } timeOut - time in ms until the model automatically closses
 */
const getConfigOptions = (modal, form) => {
  const url = form.getAttribute('action');
  const error = modal.getAttribute('data-general-error-text');
  let timeOut = modal.getAttribute("data-cart-modal-animation-timeout");
  timeOut = parseInt(timeOut) ? parseInt(timeOut) : 5000;

  return { url, error, timeOut }
}

/**
 * Insert HTML from back-end call in the modal body
 * @param { HTML } modal - HTML element that will show the response content 
 * @param { object } response - object of back-end call
 */
const insertModalContent = (modal, response) => {
  const el = modal.querySelector('.modal-card-body');

  if(el){
    // Need to be set seperatly for IE11.
    modal.classList.add('is-active');
    modal.classList.add('is-fade-out');

    el.innerHTML = response.HTML;
  }
}

/**
 * Insert HTML from back-end call in the modal body
 * @param { HTML } form - HTML element that will show the response content 
 * @param { object } errorMessage - error message from HTML attribute or from the json response
 */
const insertModalError = (form, errorMessage) => {
  const errorWrapper =  form.querySelector('.js-add-to-cart-message');
  
  if(errorWrapper){
    const errorWrapperText = errorWrapper.querySelector('.js-add-to-cart-message-text');
    errorWrapper.classList.remove('is-hidden')

    errorWrapperText.innerHTML = errorMessage;
  }
}

const setEventListeners = (modal, timeOut) => {
  document.addEventListener("click", (evt) => {
    const target = evt.target;
    const clickedInModal = modal.contains(target);

    // The Click event of the document removes the 'is-fade-out' class,
    // but the Submit event of the form adds it back, resulting in a flicker.
    // To stop this do not call the "fadeOutModal()" when clicked on the submit button or any children of it.
    const clickedOnSubmitButton = target.classList.contains('js-modal-cart-preview') || target.parentNode.classList.contains('js-modal-cart-preview');

    if(clickedInModal || clickedOnSubmitButton){
      return;
    }

    fadeOutModal(modal);
  });
  
  if(isMobileLayout()){
    // Pause closing on modal touch
    modal.addEventListener('touchstart', () => {
      clearTimeouts();
    });

    // Set automatic fadeout again when user releases modal
    modal.addEventListener('touchend', () => {
      setAutomaticFadeOut(modal, timeOut);
    });
  } else {
    // Pause closing on modal hover
    modal.addEventListener('mouseover', () => {
      // Custom debounce, bcs helper does not take parameters
      setTimeout(() => {
        clearTimeouts();
      }, 200);
    });
    
    // Set automatic fadeout again when mouseout on modal
    modal.addEventListener('mouseleave', () => {
      // Custom debounce, bcs helper does not take parameters
      setTimeout(() => {
        setAutomaticFadeOut(modal, timeOut);
      }, 200);
    });
  }

  modal.querySelector('.js-modal-close').addEventListener("click", (evt) => {
    evt.stopPropagation(); // Stop event bubbling.

    fadeOutModal(modal);
  });
}

// TimeOuts need to be accessible for the "clearTimeouts()".
let modalAutoCloseTimeOut; // Timeout until automatically closing.
let modalHideTimeOut; // Timeout for fading animation.

const setAutomaticFadeOut = (modal, timeOut) => {
  modalAutoCloseTimeOut = setTimeout(() => {
    fadeOutModal(modal);
  }, timeOut);
}

const fadeOutModal = (modal) => {
  const animationDuration = 200;

  if(!modalIsOpen(modal)){
    return;
  }

  modal.style.transitionDuration = `${animationDuration}ms`;

  modal.classList.remove('is-fade-out');

  modalHideTimeOut = setTimeout(() => {
    modal.classList.remove('is-active');
  }, animationDuration - 10);
}

/**
 * Makes sure, the modal stays open for the full duration,
 * instead of the remaining time, when the user adds a product to their cart and the modal is still open.
 * 
 * And keep the "fadeOutModal()" and "setAutomaticFadeOut()" timeOuts in-sync.
 */ 
const clearTimeouts = () => {
  clearTimeout(modalAutoCloseTimeOut);
  clearTimeout(modalHideTimeOut);
  // null used to also clear the value passed into it.
  modalAutoCloseTimeOut = null;
  modalHideTimeOut = null;
}

const modalIsOpen = modal => {
  return modal.classList.contains('is-active');
}

module.exports = shoppingCardModal;